RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.TitleDropdownItem = Marionette.ItemView.extend({
        tagName: 'li',
        template: '#commonTitleDropdownItemTemplate',
        ui: {
            link: 'a.title-menu-option'
        },
        events: {
            'click @ui.link': 'onItemClick'
        },

        className: function () {
            const me = this;
            return me.model.get('className');
        },

        templateHelpers: function () {

            const me = this;
            const href = me.model.get('href') || '#';
            return {
                href: href,
                value: me.model.get('value') || ''
            };
        },
        onItemClick: function (e) {
            const me = this;
            const hasHref = !_.isEmpty(me.model.get('href'));

            if (e && !hasHref) {
                e.preventDefault();
            }

            const action = me.model.get('action');
            if (action) {
                action.call(me, e);
            }

            const url = me.model.get('sidebarUrl');
            if (url && !_.isEmpty(url)) {
                RivalIQ.apps.Shell.execute('set:sidebar:activeUrl', url);
            }

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.UsedTitleDropdownNavigation);
            me.trigger('action', me.model.toJSON());
        }
    });

});
